var REFRESH_DEBOUNCE = 100;

var RENDER_POLL_INTERVAL = 100;

var RENDER_POLL_TIMEOUT = 15e3;

var refreshTimer;

function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
        const queue = window.KlarnaOnsite;
        if (queue && typeof queue.push === "function") queue.push({
            eventName: "refresh-placements"
        });
    }, REFRESH_DEBOUNCE);
}

function isRendered(placement) {
    if (placement.shadowRoot?.childElementCount > 0) return true;
    return Boolean(placement.querySelector("iframe")) || placement.textContent.trim() !== "";
}

function revealRow(row) {
    if (!row.hasAttribute("data-klarna-pending")) return;
    row.removeAttribute("data-klarna-pending");
    row.classList.remove("invisible");
    requestAnimationFrame(() => {
        row.classList.remove("grid-rows-[0fr]");
        row.classList.add("grid-rows-[1fr]");
    });
    let settled = false;
    const finish = () => {
        if (settled) return;
        settled = true;
        row.removeEventListener("transitionend", onTransitionEnd);
        row.classList.remove("opacity-0");
        row.classList.add("opacity-100");
    };
    const onTransitionEnd = e => {
        if (e.propertyName !== "grid-template-rows") return;
        finish();
    };
    row.addEventListener("transitionend", onTransitionEnd);
    setTimeout(finish, 350);
}

function watchPlacements() {
    const rows = document.querySelectorAll("[data-klarna-pending]");
    if (rows.length === 0) return;
    customElements.whenDefined("klarna-placement").then(() => {
        const startedAt = Date.now();
        const poll = setInterval(() => {
            if (![ ...rows ].some(row => {
                const placement = row.querySelector("klarna-placement");
                return placement && isRendered(placement);
            })) {
                if (Date.now() - startedAt < RENDER_POLL_TIMEOUT) return;
                clearInterval(poll);
                return;
            }
            clearInterval(poll);
            rows.forEach(revealRow);
        }, RENDER_POLL_INTERVAL);
    }).catch(() => {});
}

var klarna_placements_default = (() => {
    document.addEventListener("variant:change", event => {
        if (event.detail?.modal) return;
        const {variant: variant} = event.detail || {};
        if (!variant) return;
        const placements = document.querySelectorAll("klarna-placement[data-purchase-amount]");
        if (placements.length === 0) return;
        placements.forEach(placement => {
            placement.setAttribute("data-purchase-amount", variant.price);
        });
        refresh();
    });
    watchPlacements();
})();